import * as moment from 'moment';
import 'moment-timezone';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CancelModalComponent } from '../../cancel-modal/cancel-modal.component';
import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DataexchangeService } from '../../../services/dataexchange.service';
import { Order } from '../../../models/orderbook.model';
import { OrderPipe } from '../../../helpers/order.pipe';
import { StateService } from '../../../services/state.service';
import { Trade } from '../../../models/trade';
import { SixLetter } from '../../../helpers/pipes';
import { SocketService } from '../../../services/SocketService';
import { Subscription } from 'rxjs';
import { UserService } from '../../../services/user.service';
import { Price } from '../../../models/price';
import { Card } from '../../../models/card.model';
import { Direction } from '../../../models/direction';
import { ModifyOrderModalComponent } from '../../modify-order-modal/modify-order-modal.component';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../../store/state/reducers/matchboard.reducers';
import {
  getAllOrdersSelector,
  getCurrencyMappingsSelector,
  getCurrencyPairsSelector,
  getIsSuperUserSelector,
  getOnBehalfUsersSelector,
  getOrdersSelector,
  getSelectedOnBehalfUserSelector,
  getSpotPricesSelector,
  getTopOrdersSelector
} from '../../../store/state/selectors/matchboard.selectors';
import { PriceService } from '../../../services/price.service';
import { ToastrService } from 'ngx-toastr';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import { Json } from '../../../models/Json';

@Component({
  selector: 'app-orderbook',
  templateUrl: './orderbook.component.html',
  providers: [SixLetter]
})
export class OrderbookComponent implements OnInit, OnDestroy {

  @ViewChild('fileImportInput') fileImportInput: any;

  subscriptions: Array<Subscription>;
  fileName: string;
  isSuperUser: boolean;

  csvHeaders = [
    'sixLetterCode', 'quantity', 'swapPrice', 'tradeType', 'direction', 'tradedCurrency'
  ];

  // csvHeaders = [
  //   'swapPrice',
  //   'quantity',
  //   'sixLetterCode',
  //   'validity',
  //   'tradeType',
  //   'placedAs',
  //   'direction',
  //   'ocos',
  //   'previousSessionDate',
  //   'tradedCurrency',
  //   'counterPartyId'
  // ];

  csvRecords: any;
  header: boolean = true;
  csvError: string;

  OrderbookColumns: Order [] = [];
  modalRef: BsModalRef;
  public today = Date.now();

  Tenors = [];

  // Table sort
  order: {
    timestamp?: number,
    sixLetterCode?: number,
    swap?: number,
    validity?: number,
    quantity?: number,
    profit?: number
  } = {
    timestamp: -1,
    sixLetterCode: 1,
    swap: 0,
    validity: 0,
    quantity: 0,
    profit: 0
  };
  reverse: boolean = false;
  collection: any[] = this.OrderbookColumns;
  sortedCollection: any[];

  selectedFile: File;

  users: any = {};

  tzlocal = moment.tz.guess();
  serverTimeOffset = moment.tz('America/New_York').utcOffset(); // -300  New York UTC-5 hours
  localTimeoffset = moment.tz(this.tzlocal).utcOffset();  // 60
  localDif = this.localTimeoffset / 60;
  timeOffset = (this.serverTimeOffset - this.localTimeoffset) / 60 + this.localDif; // 420 / 7
  timeOff = this.timeOffset * 60;

  selectedOnBehalfUser: string;

  allOrders: any[];

  spotPrices: any;

  currencyMappings: any;

  currencyPairs: any;

  topOrders: any;

  constructor(
    private readonly modalService: BsModalService,
    private readonly stateService: StateService,
    private readonly socketService: SocketService,
    private readonly orderPipe: OrderPipe,
    private readonly dataexchangeService: DataexchangeService,
    private readonly userService: UserService,
    private readonly toastrService: ToastrService,
    private readonly ngxCsvParser: NgxCsvParser,
    private readonly renderer: Renderer2,
    private readonly store: Store<MatchBoardState>,
    private readonly priceService: PriceService
  ) {
    this.sortedCollection = orderPipe.transform(this.collection, 'profit');
    this.subscriptions = new Array<Subscription>();
  }

  openCancelModal(item: Order) {
    const initialState = {
      trade: new Trade(item.id, item.sixLetterCode, item.quantity, item.profit, item.profit,  this.getCurrentMarket(item.sixLetterCode), 0, 'orderBook', item.direction, item.ocoLinkId),
      selectedTenorId: item.swap
    };

    this.modalRef = this.modalService.show(CancelModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,  // enable Esc
      class: 'modal-lg modal-cancel',
      initialState
    });

    this.modalRef.content.closeBtnName = 'Close';
  }

  getCurrentMarket(sixLetterCode: string) {
    return this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, sixLetterCode);
  }

  setOrder(value: string) {
    if (!Object.keys(this.order).includes(value) || this.order[value] === 0) {
      this.order[value] = 1;
      return;
    }

    if (this.order[value] === 1) {
      this.order[value] = -1;
      return;
    }
    this.order[value] = 0;
  }

  // Repeat empty <TR>
  Arr = Array;
  num: number = 5;

  ngOnInit() {
    this.Tenors = [
      {id: 1, name: 'O/N', value: 'ON'},
      {id: 2, name: 'Ti', value: 'TI'},
      {id: 3, name: 'TOD-TOM', value: 'TOD_TOM'},
      {id: 4, name: '1w', value: 'W1'},
      {id: 5, name: '2w', value: 'W2'}
    ];
    this.subscriptions.push(
      this.dataexchangeService.orders.subscribe((orders: Order[]) => {
        this.OrderbookColumns = orders;
        // orders.forEach(o => {
        //   if (o.ocoLinkId) {
        //     if (o.id === o.ocoLinkId) {
        //       this.OrderbookColumns.push(o);
        //     }
        //   } else {
        //     this.OrderbookColumns.push(o);
        //   }
        // });
      })
    );

    // this.OrderbookColumns = [];
    // const orders = this.stateService.getOrders();
    // this.OrderbookColumns = this.stateService.getOrders();

    this.subscriptions.push(this.store.select(getIsSuperUserSelector).subscribe((isSuperUser) => {
      this.isSuperUser = isSuperUser;
    }));

    this.subscriptions.push(this.store.select(getSelectedOnBehalfUserSelector).subscribe((selectedUser) => {
      this.selectedOnBehalfUser = selectedUser;
    }));

    this.subscriptions.push(this.store.select(getTopOrdersSelector).subscribe((topOrders) => {
      this.topOrders = topOrders;
    }));

    this.subscriptions.push(this.store.select(getOrdersSelector).subscribe((orders) => {
      if (orders) {
        this.OrderbookColumns = _.clone(Object.values(orders));
      }
    }));

    if (this.userService.isSuperUser()) {
      this.store.select(getAllOrdersSelector).subscribe((allOrders) => {
        if (allOrders) {
          this.allOrders = _.clone(Object.values(allOrders));
        }
      });
    }

    this.subscriptions.push(this.store.select(getCurrencyMappingsSelector).subscribe((currencyMappings) => {
      this.currencyMappings = currencyMappings;
    }));

    this.subscriptions.push(this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairs = new Json(currencyPairs, 'sixLetterCode');
    }));

    this.subscriptions.push(this.store.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    }));

    // orders.forEach(o => {
    //   if (o.ocoLinkId) {
    //     if (o.id === o.ocoLinkId) {
    //       this.OrderbookColumns.push(o);
    //     }
    //   } else {
    //     this.OrderbookColumns.push(o);
    //   }
    // });


    // this.socketService.onClientStateChanged().subscribe((state) => {
    //   if (state.orders) {
    //     this.OrderbookColumns = state.orders;
    //     this.stateService.setOrders(state.orders);
    //   }
    // });

    this.subscriptions.push(this.store.select(getOnBehalfUsersSelector).subscribe((onBehalfUsers) => {
      onBehalfUsers
        .forEach(u => {
          this.users[u.id] = u;
        });
    }));

    // this.stateService.getOnBehalfUsers()
    //   .forEach(u => {
    //     this.users[u.id] = u;
    //   });
  }

  cancelAllOrders() {
    if (this.userService.isSuperUser())  {
      this.socketService.send('cancelOrder', {userId: this.selectedOnBehalfUser, orderIds: this.OrderbookColumns.map(o => o.id)});
    } else {
      this.socketService.send('cancelOrder', {orderIds: this.OrderbookColumns.map(o => o.id)});
    }
  }

  getClass(property: string) {
    if (!this.order[property] || this.order[property] === 0) {
      return 'icon-with';
    }
    if (this.order[property] === -1) {
      return 'fa-chevron-up';
    }
    return 'fa-chevron-down';
  }

  openModifyOrderModal(event) {
    const from = 'orderbook';
    this.renderer.addClass(document.body, 'modal-open');
    let priceBorrow: Price[];
    let priceLend: Price[];

    const card = new Card(event.sixLetterCode);
    card.swap = event.swap;
    priceBorrow = this.getPricesForCurrencyPair(card, Direction.BORROW);
    priceLend = this.getPricesForCurrencyPair(card, Direction.LEND);

    // const spot = this.stateService.getSpotPriceForCurrencyPair(event.sixLetterCode);
    const spot = this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, event.sixLetterCode);

    let swap = card.swap;
    if (swap === 'ON') {
      swap = 'O/N';
    }
    const initialState = {
      trade: new Trade(null,
        event.sixLetterCode,
        event.quantity,
        priceBorrow && priceBorrow[0] ? priceBorrow[0].price : 0,
        priceLend && priceLend[0] ? priceLend[0].price : 0,
        spot,
        event.quantity * spot,
        from,
        event.stpTradeDirection),
      order: event,
      ocoOrders: event.ocoLinkId ?
        this.userService.isSuperUser() ? this.allOrders.filter(o => o.ocoLinkId === event.ocoLinkId && o.ocoLinkId !== o.id) : this.OrderbookColumns.filter(o => o.ocoLinkId === event.ocoLinkId && o.ocoLinkId !== o.id) :
        null,
      selectedTenorId: this.Tenors.find(t => t.name.toUpperCase() === swap).value
    };

    this.modalRef = this.modalService.show(ModifyOrderModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true,  // enable Esc
      class: 'modal-lg modal-trade',
      initialState
    });

    this.modalRef.content.closeBtnName = 'Close';
  }

  getPricesForCurrencyPair(card, direction): Array<Price> {
    // const pricesForCurrencyPair = this.stateService.getTopOrdersForCurrencyPair(card.sixLetterCode);
    const pricesForCurrencyPair = this.topOrders[card.sixLetterCode];
    if (!pricesForCurrencyPair) {
      return null;
    }

    const priceForCp = pricesForCurrencyPair[direction];
    if (priceForCp) {
      const prices = priceForCp.filter(p => p.swap === card.swap);
      return prices.length > 0 ? prices : null;
    }

    return priceForCp;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onFileSelected(event) {
    const file:File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.selectedFile = file;
      this.selectedFile.text().then((orders) => {
        console.log(orders)
      })
    }
  }

  submitUploadFile() {
    this.socketService.send('addOrders', {orders: this.csvRecords});
    this.csvRecords = null;
    this.fileImportInput.nativeElement.value = '';
    // const formData = new FormData();
    // formData.append('csv', this.selectedFile);
    // this.socketService.send()
    // this.stpService.uploadCSV(formData).subscribe({
    //   next: (result) => {
    //     result.forEach(r => {
    //       this.results.push(r);
    //     })
    //     this.toastrService.success('Trades sent successfully.');
    //   },
    //   error: (error) => {
    //     this.toastrService.error(error.message);
    //   }
    // });
  }

  fileChangeListener(event: any): void {
    const files = event.target.files;
    if (files.length === 0) {
      this.csvRecords = null;
      return;
    }
    // this.header = (this.header as unknown as string) === 'true' || this.header === true;

    this.ngxCsvParser.parse(files[0], { header: false, delimiter: ','})
      .pipe().subscribe({
      next: (result): void => {
        if (Array.isArray(result) && result.length > 1) {
          if (this.isHeaderEquals(result[0])) {
            this.csvError = null;
            this.csvRecords = [];
            result.forEach((r, i) => {
              if (i > 0) {
                this.csvRecords.push({
                  [this.csvHeaders[0]]: r[0],
                  [this.csvHeaders[1]]: Number(r[1]),
                  [this.csvHeaders[2]]: Number(r[2]),
                  [this.csvHeaders[3]]: r[3],
                  [this.csvHeaders[4]]: r[4],
                  [this.csvHeaders[5]]: r[5],
                  ocos: []
                })
              }
            })
          } else {
            this.csvRecords = null;
            // this.fileImportInput.nativeElement.value = '';
            this.csvError = 'Wrong csv file';
          }
        } else {
          this.csvRecords = null;
          this.csvError = result['message'];
        }

      },
      error: (error: NgxCSVParserError): void => {
        console.log('Error', error);
      }
    });
  }

  isHeaderEquals(headers: string[]): boolean {
    return this.csvHeaders[0] === headers[0] && this.csvHeaders[1] === headers[1] && this.csvHeaders[2] === headers[2] && this.csvHeaders[3] === headers[3] && this.csvHeaders[4] === headers[4] && this.csvHeaders[5] === headers[5];
  }
}
